var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { RegistrationStatus, } from '@la/types';
import { getAccessToken, getBaseURL } from '@la/utilities';
import { getRegistrationsPricing } from './getRegistrationsPricing';
import { getTournamentRegistrations } from './getTournamentRegistrations';
const baseUrl = getBaseURL();
const sendRegistrationsForInvoice = ({ state, siteId, }) => __awaiter(void 0, void 0, void 0, function* () {
    const endpoint = `${baseUrl}/api/mgmt-console/${siteId}/registrations`;
    const token = getAccessToken();
    const tournamentRegistrations = yield getTournamentRegistrations({
        payerId: state.payer.id.toString(),
        siteDomain: 'manager',
        siteId: siteId,
        tournamentId: state.wizardState.tournament.id,
    });
    const registrationsForUser = tournamentRegistrations.divisions
        .map((division) => division.registrationsForUser)
        .flat();
    const registrationsToInvoice = registrationsForUser.filter((registration) => {
        return (registration.registeringUserId === state.payer.id &&
            registration.registrationStatus === RegistrationStatus.Created);
    });
    const pricing = yield getRegistrationsPricing({
        siteDomain: 'manager',
        siteId: siteId,
        registrationIds: registrationsToInvoice.map((reg) => reg.id),
    });
    const ngPaymentPlanId = !state.selectedPaymentOption ||
        state.selectedPaymentOption === 'pay-in-full'
        ? undefined
        : state.selectedPaymentOption;
    const payload = {
        payingUserId: state.payer.id,
        registrationSummary: createRegistrationSummary(state, registrationsToInvoice, pricing, ngPaymentPlanId),
        siteId: parseInt(siteId),
        version: 1,
    };
    const response = yield axios.post(endpoint, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
});
export const createRegistrationSummary = (state, registrations, pricing, ngPaymentPlanId) => {
    return registrations.map((registration) => {
        var _a, _b, _c;
        const registrationPricing = pricing.programPricings
            .find((p) => p.programId === registration.programId)
            .pricings.find((p) => p.registrationId === registration.id);
        const basePrice = (_a = registrationPricing === null || registrationPricing === void 0 ? void 0 : registrationPricing.price) !== null && _a !== void 0 ? _a : '0.00';
        let overrideDescription;
        if (registrationPricing === null || registrationPricing === void 0 ? void 0 : registrationPricing.priceAdjustmentDetails) {
            const { priceAdjustmentDetails } = registrationPricing;
            overrideDescription = `${priceAdjustmentDetails.formFieldLabel} - ${priceAdjustmentDetails.formFieldValue}`;
        }
        if (!ngPaymentPlanId) {
            return {
                amount: basePrice,
                externalRegistrationId: registration.id,
                ngPaymentPlanId: ngPaymentPlanId,
                programId: registration.programId,
                programStaffId: 14389,
                userId: state.payer.id,
                usingTeamPlayerPay: false,
                variableTeamFee: false,
                overrideDescription,
            };
        }
        const summary = (_b = state.paymentPricing) === null || _b === void 0 ? void 0 : _b.find((summary) => summary.ngPaymentPlanId === ngPaymentPlanId);
        // Find the payment plan adjusted amount based on the program id and the
        // basePrice (all registrations within a program that have the same base price will
        // have the same adjusted amount)
        const paymentPlan = summary === null || summary === void 0 ? void 0 : summary.lineItems.find((item) => item.subprogramId === registration.programId.toString() &&
            item.basePrice === parseFloat(basePrice));
        const amount = paymentPlan === null || paymentPlan === void 0 ? void 0 : paymentPlan.amount;
        const priceAdjustments = state.teamPriceAdjustments[registration.programId.toString()];
        let conditionalPriceOverrides;
        if (priceAdjustments && Object.keys(priceAdjustments).length > 0) {
            conditionalPriceOverrides = paymentPlan === null || paymentPlan === void 0 ? void 0 : paymentPlan.installments.map((installment) => ({
                amountDue: installment.total,
                paymentDate: installment.paymentDate,
                processingFee: 0,
            }));
        }
        return {
            amount: (_c = amount.toString()) !== null && _c !== void 0 ? _c : '0.00',
            externalRegistrationId: registration.id,
            ngPaymentPlanId: ngPaymentPlanId,
            programId: registration.programId,
            programStaffId: 14389,
            userId: state.payer.id,
            usingTeamPlayerPay: false,
            variableTeamFee: false,
            overrideDescription,
            conditionalPriceOverrides,
        };
    });
};
export { sendRegistrationsForInvoice };
